/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Flags } from './Flags';
import type { TrackingInfo } from './TrackingInfo';
export type Order = {
    /**
     * Unique ID of the order.
     */
    orderID: string;
    /**
     * Unique ID of the original order if there was one.
     */
    reorderofID?: string;
    /**
     * Unique ID of the user ordering.
     */
    userID?: string;
    /**
     * Unique ID of the company that's ordered from.
     */
    companyID?: string;
    /**
     * Unique ID of the store that's ordered from.
     */
    storeID?: string;
    /**
     * Unique ID of the current session.
     */
    sessionID?: string;
    /**
     * EDSER order ID.
     */
    edserOrderId?: string;
    /**
     * Status of the order.
     */
    status?: Order.status;
    /**
     * Total cost of the order.
     */
    totalCost?: number;
    /**
     * Who created this order?
     */
    createdBy?: string;
    /**
     * When was this order created?
     */
    createdAt?: string;
    /**
     * First name of the customer.
     */
    firstName?: string;
    /**
     * Last name of the customer.
     */
    lastName?: string;
    /**
     * The customer's gender.
     */
    gender?: string;
    /**
     * The order's tracking info.
     */
    trackingInfo?: TrackingInfo;
    /**
     * The order's shipping number.
     */
    shippingNumber?: string;
    /**
     * The order's tracking link.
     */
    trackingLink?: string;
    /**
     * List of the ordered items.
     */
    items?: Array<Record<string, any>>;
    /**
     * Flags set for this order.
     */
    flags?: Flags;
    /**
     * Leroy Metadata
     */
    leroyMeta?: string;
    /**
     * Prescription object based on input data.
     */
    prescriptionObj?: Record<string, any>;
    /**
     * Foot scan ID-s for each leg.
     */
    measurementIDs?: Record<string, any>;
};
export namespace Order {
    /**
     * Status of the order.
     */
    export enum status {
        PROCESSING = 'Processing',
        FABRICATING = 'Fabricating',
        SHIPPED = 'Shipped',
        CANCELLED = 'Cancelled',
    }
}

